/**
 * プロジェクト詳細ページ
 * プロジェクトの詳細情報表示
 */

import ProjectDetailClient from '@/features/projects/components/ProjectDetailClient'

/**
 * 静的サイト生成用のパラメータ生成
 */
export async function generateStaticParams() {
  try {
    console.log('[generateStaticParams] Generating static params for project pages')

    const staticProjectIds = [
      '00000000-0000-0000-0000-000000000001',
      '00000000-0000-0000-0000-000000000002',
      '00000000-0000-0000-0000-000000000003',
    ]

    return staticProjectIds.map((id) => ({
      project_id: id,
    }))
  } catch (error) {
    console.error('[generateStaticParams] Error generating static params:', error)
    return []
  }
}

/**
 * プロジェクト詳細ページコンポーネント
 */
export default function ProjectDetailPage() {
  return <ProjectDetailClient />
}